var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"btn",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$store.commit('showGroupsCateringModal',true)}}},[_c('i',{staticClass:"fas fa-fw fa-file"}),_vm._v("\n        Sample Catering Menu\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }